module.exports = __webpack_public_path__ + "media/fuel_types/u95-67ad96c8.png";